<template>
    <div v-loading="$parentInfo.studentCart.loading" style="width: 100%">
        <div style="text-align: right">
            <el-button type="primary" size="mini" @click="handleTryingCart">试听
            </el-button>
        </div>
        <div v-if="orderCarts.length>0" @click="cartType('class')">
            <div style="height: 20px">
                班级
            </div>
            <classCart></classCart>
        </div>
        <div v-if="orderCartClassHours.length>0" @click="cartType('classHour')">
            <div style="height: 20px">
                课次
            </div>
            <classHourCart></classHourCart>
        </div>
        <div v-if="orderCartShops.length>0" @click="cartType('shop')">
            <div style="height: 20px">
                商店
            </div>
            <shopCart></shopCart>
        </div>
        <div style="text-align: right">
            <el-button type="primary" size="mini" :disabled="!$parentInfo.studentCart.settleCheck"
                       @click="settleAccount">结算
            </el-button>
        </div>
    </div>
</template>

<style scoped>
    .table .el-row {
        margin-bottom: 0px;
    }

    .item {
        padding: 5px 0;
        height: 38px;
        margin: 0;
        border-bottom: 1px solid #EEEEEE;
    }

    .table thead th, .table th {
        border: 0px;
        font-size: 14px;
        color: #8d989d;
    }

    .table .el-form-item {
        margin: 0;
    }
</style>


<script>
    import classCart from './component/ClassCart';
    import classHourCart from './component/ClassHourCart';
    import shopCart from './component/ShopCart';
    export default {
        data() {
            return {
                // parentInfo: '',
                isIndeterminate: false,
                hasChosenAll: true,
                multipleSelection: [],
                classHourMultipleSelection: [],
                shopMultipleSelection: [],
                classClick:true,
                classHourClick:true,
                shopClick:true,
                cartTypeHeight:10,
                hasClick:false,
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowStudentCart();
        },
        components: {
            'classCart':classCart,
            'classHourCart': classHourCart,
            'shopCart': shopCart,
        },
        computed: {
            orderCarts: function () {
                return this._.values(this.$parentInfo.studentCart.studentCartData);
            },
            orderCartClassHours: function () {
                return this._.values(this.$parentInfo.studentCart.studentCartClassHourData);
            },
            orderCartShops: function () {
                return this._.values(this.$parentInfo.studentCart.studentCartShopData);
            },
            remainPay: function () {
                let sum = 0;
                for (const key in this.$parentInfo.studentCart.invoiceForm.payment_types) {
                    if (this.$parentInfo.studentCart.invoiceForm.payment_types[key].balance) {
                        sum += parseFloat(this.$parentInfo.studentCart.invoiceForm.payment_types[key].balance);
                    }
                }
                return this.$parentInfo.studentCart.sumPay - sum;
            },
            row:function(){
                var row=0;
                if(this.orderCarts.length>0){
                    row++;
                }
                if(this.orderCartClassHours.length>0){
                    row++;
                }
                if(this.orderCartShops.length>0){
                    row++;
                }
                if(this.hasClick){
                    row=1;
                }
                return row
            }
        },
        methods: {
            cartType(type){
                this.hasClick=true;
                this.cartTypeHeight=40;
                if(type=='class'){
                    this.classClick=true;
                    this.classHourClick=false;
                    this.shopClick=false;
                }else if(type=='classHour'){
                    this.classHourClick=true;
                    this.classClick=false;
                    this.shopClick=false;
                }else if(type=='shop'){
                    this.classClick=false;
                    this.classHourClick=false;
                    this.shopClick=true;
                }
            },
            //显示购物车信息 true
            handleShowStudentCart() {
                this.$wApi.send(this.$parentInfo.path, 'get_student_carts', {
                    'student_id': this.$parentInfo.student_id,
                })
            },
            settleAccount() {
                if (this.$parentInfo.studentCart.chosenCart.length === 0
                    && this.$parentInfo.studentCart.chosenClassHourCart.length===0
                    && this.$parentInfo.studentCart.chosenShopCart.length===0) {
                    this.$message({
                        type: 'error',
                        message: '没有选中课程不能结算'
                    });
                } else {
                    this.$parentInfo.studentCart.sumPay = 0;
                    Object.keys(this.$parentInfo.studentCart.studentCartData).forEach((item) => {
                        for (let i = 0; i < this.$parentInfo.studentCart.chosenCart.length; i++) {
                            if (this.$parentInfo.studentCart.chosenCart[i] == item) {
                                if(this.$parentInfo.studentCart.studentCartData[item].first_sum_price <0){
                                    this.$parentInfo.studentCart.sumPay += (this.$parentInfo.studentCart.studentCartData[item].sum_price_type
                                        + this.$parentInfo.studentCart.studentCartData[item].coupons
                                        + this.$parentInfo.studentCart.studentCartData[item].use_classHours);
                                }else{
                                    this.$parentInfo.studentCart.sumPay += (this.$parentInfo.studentCart.studentCartData[item].sum_price_type
                                        - this.$parentInfo.studentCart.studentCartData[item].coupons
                                        - this.$parentInfo.studentCart.studentCartData[item].use_classHours);
                                }
                            }
                        }
                    });
                    Object.keys(this.$parentInfo.studentCart.studentCartClassHourData).forEach((item) => {
                        for (let i = 0; i < this.$parentInfo.studentCart.chosenClassHourCart.length; i++) {
                            if (this.$parentInfo.studentCart.chosenClassHourCart[i] == item) {
                                this.$parentInfo.studentCart.sumPay += this.$parentInfo.studentCart.studentCartClassHourData[item].sum_price;
                            }
                        }
                    });
                    Object.keys(this.$parentInfo.studentCart.studentCartShopData).forEach((item) => {
                        for (let i = 0; i < this.$parentInfo.studentCart.chosenShopCart.length; i++) {
                            if (this.$parentInfo.studentCart.chosenShopCart[i] == item) {
                                this.$parentInfo.studentCart.sumPay += this.$parentInfo.studentCart.studentCartShopData[item].sum_price;
                            }
                        }
                    });

                    this.$Win.openModal('Dialog_SettleAccounts', 1224, 900, '结算', {
                        'student_id': this.$parentInfo.student_id,
                        'selections': this.$parentInfo.studentCart.chosenCart,
                        'choose_cart_classHour_ids': this.$parentInfo.studentCart.chosenClassHourCart,
                        'choose_cart_shop_ids': this.$parentInfo.studentCart.chosenShopCart
                    });
                }
            },
            handleTryingCart(){
                this.$Win.openModal('Dialog_TryingCart', 900, 500, '试听', {
                });
            }
        }
    };
</script>
